import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from '@material-ui/core';
import dashimg from '../../images/dash-img1.png';
import SettlementDetail from '../Tutorial/settlementTutorial';
import 'react-dropdown/style.css';


class Tutorial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openTutorial1Dialog: false,
      openTutorial2Dialog: false,
      openTutorial3Dialog: false,
      openTutorial5Dialog: false,
      openTutorial4Dialog: false,
      openInfoDialog: false,
    };
  }

  handleClose = () => {
    this.setState({ openTutorial1Dialog: false });
  };

    handleCloseDialogueInfo = () => {
      this.setState({ openInfoDialog: false, openTutorial2Dialog: false });
    };

    handleCloseTutorial2 = () => {
      this.setState({ openTutorial2Dialog: false });
    };

    handleCloseTutorial3 = () => {
      this.setState({ openTutorial3Dialog: false });
    };

    handleCloseTutorial5 = () => {
      this.setState({ openTutorial5Dialog: false });
    };

    handleCloseTutorial4 = () => {
      this.setState({ openTutorial4Dialog: false });
    };

    openTutorial1 = () => {
      this.setState({ openTutorial1Dialog: true, openInfoDialog: false });
    };

    openTutorial2 = () => {
      this.setState({ openTutorial2Dialog: true, openTutorial1Dialog: false, openInfoDialog: false });
    };

    openTutorial3 = () => {
      this.setState({ openTutorial2Dialog: false, openTutorial3Dialog: true });
    };

    openTutorial4 = () => {
      this.setState({ openTutorial3Dialog: false, openTutorial4Dialog: true });
    };

     openTutorial5 = () => {
       this.setState({ openTutorial3Dialog: false, openTutorial5Dialog: true });
     };

    openTutorial6 = () => {
      this.setState({ openTutorial5Dialog: false, openTutorial4Dialog: true });
    };

    openDialogInfo = () => {
      this.setState({ openInfoDialog: true, openTutorial2Dialog: false });
    };

    render() {
      return (
        <span>
          <button className="btn waves-effect waves-light primary-btn faq-tutorial" onClick={this.openTutorial1}>
Tutorial
            {' '}
            <i className="material-icons">arrow_forward</i>
            {' '}
          </button>
          <Dialog
            open={this.state.openTutorial1Dialog}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            id="form-1dialog-title"
            className="tutorial-background-color"
            maxWidth="md"
            opacity="0.8"
            disableBackdropClick
          >
            <div id="tutorial-pop">
              <DialogTitle id="form-dialog-title" />
              <DialogContent>
                <div className="tutorial-arrow">
                  <i className="material-icons">arrow_downward</i>
                </div>
                <p><a className="start-tutorial" onClick={this.openTutorial2}>Lets Get Started</a></p>
              </DialogContent>
              <DialogActions />
            </div>
          </Dialog>

          <Dialog
            open={this.state.openTutorial2Dialog}
            onClose={this.handleCloseTutorial2}
            aria-labelledby="form-dialog-title"
            id="form-2dialog-title"
            maxWidth="md"
            className="tutorial-background-color"
            disableBackdropClick
          >
            <div id="tutorial-pop">
              <DialogTitle id="form-dialog-title" />
              <DialogContent>
                <div className="tutorial-onboard">
                  <div className="tutorial-question center-align">
Want more Information? Simply Click
                    {' '}
                    <span>Settlement Details</span>
                    {' '}
to see all the cases details.
                  </div>
                  <div className="tutorial-detail">
                    <div className="tutorial-arrow">
                      <i className="material-icons">arrow_downward</i>
                    </div>
                    <div className="row ">
                      <div className="col m3 l2">
                        <div className="img-box"><img src={dashimg} alt="dashimg" /></div>
                      </div>
                      <div className="col m6 l7">
                        <h5>
Reddylce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                        <p>Redylce has a class action suit against it and you could be eligible for reimbursement. Let,s get started:</p>
                      </div>
                      <div className="col m3">
                        <a className="detail">Settlement Details</a>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col m12">
                        <a className="waves-effect waves-light btn btn-blue save-changes">Click Here to Apply</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tutorial-btns">
                  <a className="waves-effect waves-light btn" onClick={this.handleCloseTutorial2}>Skip</a>
                  {' '}
                  <a
                    onClick={this.openTutorial3}
                    className="waves-effect waves-light btn"
                  >
Next

                  </a>
                </div>
              </DialogContent>
              <DialogActions />
            </div>
          </Dialog>
          <Dialog
            open={this.state.openTutorial3Dialog}
            onClose={this.handleCloseTutorial3}
            aria-labelledby="form-dialog-title"
            id="form-3dialog-title"
            className="tutorial-background-color"
            maxWidth="md"
            disableBackdropClick
          >
            <div id="tutorial-pop">
              <DialogTitle id="form-dialog-title" />
              <DialogContent>
                <div className="tutorial-onboard">
                  <div className="tutorial-question center-align">Just answer questions on open cases to check your eligibility</div>
                  <div className="tutorial-detail">
                    <div className="row ">
                      <div className="col m3 l2">
                        <div className="img-box"><img src={dashimg} alt="dashimg" /></div>
                      </div>
                      <div className="col m9 l7">
                        <h5>
Reddylce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                        <p>Redylce has a class action suit against it and you could be eligible for reimbursement. Let,s get started:</p>
                        <h6>1-Step Enrollment</h6>
                        <span>How many bags of reddyice hav you purchased since 2007?</span>
                        <div className="tutorial-pop-btns">
                          <div className="tutorial-arrow2">
                            <i className="material-icons">arrow_forward</i>
                          </div>
                          <a className="waves-effect waves-light btn primary-btn left">0 bags</a>
                          <a className="waves-effect waves-light btn primary-btn left">1-6 bags</a>
                          <a className="waves-effect waves-light btn btn-blue save-changes left">
7+bags

                          </a>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="tutorial-btns">
                  <a className="waves-effect waves-light btn" onClick={this.handleCloseTutorial3}>Skip</a>
                  {' '}
                  <a
                    onClick={this.openTutorial5}
                    className="waves-effect waves-light btn"
                  >
Next

                  </a>
                </div>
              </DialogContent>
            </div>
          </Dialog>


          <Dialog
            open={this.state.openTutorial5Dialog}
            onClose={this.handleCloseTutorial5}
            aria-labelledby="form-dialog-title"
            id="form-2dialog-title"
            maxWidth="md"
            className="tutorial-background-color"
            disableBackdropClick
          >
            <div id="tutorial-pop">
              <DialogTitle id="form-dialog-title" />
              <DialogContent>
                <div className="tutorial-onboard">
                  <div className="tutorial-question center-align">
                    {' '}
Please click
                    {' '}
                    <i className="material-icons hide-icon">visibility_off</i>
                    {' '}
on the hide option, if the settlement is not relevant to you.
                  </div>
                  <div className="tutorial-detail">

                    <div className="row ">
                      <div className="col m3 l2">
                        <div className="img-box"><img src={dashimg} alt="dashimg" /></div>
                        <div className="tutorial-icons">
                          <span className="hide hide-seetlementtext">Hide&nbsp;</span>
                          <i className="material-icons view-icon">visibility_off</i>
                          <div className="tutorial-arrow">
                            <i className="material-icons">arrow_backward</i>

                          </div>
                        </div>
                      </div>
                      <div className="col m6 l7">
                        <h5>
Reddylce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                        <p>Redylce has a class action suit against it and you could be eligible for reimbursement. Let,s get started:</p>
                      </div>

                      <div className="col m3">
                        <a className="detail">Settlement Details</a>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col m12">
                        <a className="waves-effect waves-light btn btn-blue save-changes">Click Here to Apply</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tutorial-btns">
                  <a className="waves-effect waves-light btn" onClick={this.handleCloseTutorial5}>Skip</a>
                  {' '}
                  <a
                    onClick={this.openTutorial6}
                    className="waves-effect waves-light btn"
                  >
Next

                  </a>
                </div>
              </DialogContent>
              <DialogActions />
            </div>
          </Dialog>

          <Dialog
            open={this.state.openTutorial4Dialog}
            onClose={this.handleCloseTutorial4}
            aria-labelledby="form-dialog-title"
            id="form-4dialog-title"
            className="tutorial-background-color"
            maxWidth="md"
            disableBackdropClick
          >
            <div id="tutorial-pop">
              <DialogTitle id="form-dialog-title" />
              <DialogContent>
                <div className="tutorial-started">
                  <h4>Let's get started</h4>
                  <p>Take me to dashbord to see settlement that provide ways for me to contact.</p>
                  <button
                    className="btn waves-effect waves-light primary-btn"
                    name="action"
                    onClick={this.handleCloseTutorial4}
                  >
Show me the settlements.
                    <i className="material-icons right">arrow_forward</i>
                  </button>
                </div>
              </DialogContent>
            </div>
          </Dialog>
          <Dialog
            open={this.state.openInfoDialog}
            onClose={this.handleCloseDialogueInfo}
            aria-labelledby="form-dialog-title"
            id="form-5dialog-title"
            className="tutorial-background-color"
            maxWidth="md"
            disableBackdropClick
          >
            <div className="pop-up-eligbility">
              <DialogTitle id="form-dialog-title">
Settlement Information
                <DialogActions className="pop-close">
                  <Button onClick={this.handleCloseDialogueInfo} color="primary">
                                            X
                  </Button>
                </DialogActions>
              </DialogTitle>

              <DialogContent>
                <SettlementDetail />
              </DialogContent>

            </div>
            <div className="tutorial-btns">
              <a className="waves-effect waves-light btn" onClick={this.handleCloseDialogueInfo}>Skip</a>
              {' '}
              <a
                onClick={this.openTutorial2}
                className="waves-effect waves-light btn"
              >
Next

              </a>
            </div>
          </Dialog>
        </span>
      );
    }
}

export default Tutorial;
